import { render, staticRenderFns } from "./WhoIsWatching.vue?vue&type=template&id=2d51f946&"
import script from "./WhoIsWatching.vue?vue&type=script&lang=js&"
export * from "./WhoIsWatching.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports